import { ErrorInfo } from '../shared/interfaces/error-info.interface';
import { ApplyToLookupOptions, ApplyToOptionData, PromoCodeRow, PromotionApiModel } from './types';

function formatTimestamp(timestamp?: number) {
  if (!timestamp) return '-';

  return new Date(timestamp).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
}

function mapIdsToLabels(ids: string[] = [], options: ApplyToOptionData[] = []) {
  return ids.map((id) => options.find((option) => option.id === id)?.label || id);
}

export function mapPromotionToRow(
  promotion: PromotionApiModel,
  lookupOptions?: ApplyToLookupOptions
): PromoCodeRow {
  const isActive = promotion.isActive ?? promotion.active ?? true;
  const appliedTo = [
    ...mapIdsToLabels(promotion.areaIds, lookupOptions?.area),
    ...mapIdsToLabels(promotion.cityIds, lookupOptions?.city),
    ...mapIdsToLabels(promotion.propertyIds, lookupOptions?.property)
  ];

  return {
    id: promotion.id || promotion.name || '-',
    code: promotion.name || '-',
    discountValue:
      typeof promotion.value === 'number' ? `${Math.round(promotion.value * 100)}%` : '-',
    startDate: formatTimestamp(promotion.availableFrom),
    endDate: formatTimestamp(promotion.availableTo),
    appliedTo,
    status: isActive ? 'Active' : 'Deactivated',
    isActive
  };
}

export function mapLookupOptions(
  items: { id?: string; name?: string; label?: string }[]
): ApplyToOptionData[] {
  return items
    .filter((item) => item.id && (item.name || item.label))
    .map((item) => ({ id: item.id || '', label: item.name || item.label || '' }));
}

export function isLookupList<T>(items: T[] | ErrorInfo): items is T[] {
  return Array.isArray(items);
}
